const copies = {
  pt: {
    close: 'Fechar seleção',
    title: 'Escolha seu perfil', intro: 'Conte para a gente como você vai usar o Jobifull.', back: 'Voltar', continue: 'Continuar', pending: 'Aguarde…', empty: 'Nenhum perfil disponível para esta ação. Volte para continuar no site.', failed: 'Não foi possível abrir o perfil. Tente novamente.',
    roles: {
      professional: { title: 'Profissional', description: 'Encontre vagas, construa seu perfil e desenvolva sua carreira.' },
      company: { title: 'Empresa', description: 'Publique vagas, encontre talentos e fortaleça sua marca empregadora.' },
      recruiter: { title: 'Recrutador', description: 'Gerencie processos seletivos e encontre talentos para a empresa.' }
    }
  },
  es: {
    close: 'Cerrar selección',
    title: 'Elige tu perfil', intro: 'Cuéntanos cómo vas a usar Jobifull.', back: 'Volver', continue: 'Continuar', pending: 'Espera…', empty: 'No hay perfiles disponibles para esta acción. Vuelve para continuar en el sitio.', failed: 'No se pudo abrir el perfil. Inténtalo de nuevo.',
    roles: {
      professional: { title: 'Profesional', description: 'Encuentra ofertas, crea tu perfil y desarrolla tu carrera.' },
      company: { title: 'Compañía', description: 'Publica ofertas, encuentra talento y fortalece tu marca empleadora.' },
      recruiter: { title: 'Reclutador', description: 'Gestiona procesos de selección y encuentra talento para la empresa.' }
    }
  },
  en: {
    close: 'Close selection',
    title: 'Choose your profile', intro: 'Tell us how you will use Jobifull.', back: 'Back', continue: 'Continue', pending: 'Please wait…', empty: 'No profiles are available for this action. Go back to continue on the site.', failed: 'Could not open the profile. Please try again.',
    roles: {
      professional: { title: 'Professional', description: 'Find jobs, build your profile and develop your career.' },
      company: { title: 'Company', description: 'Publish jobs, find talent and strengthen your employer brand.' },
      recruiter: { title: 'Recruiter', description: 'Manage selection processes and find talent for the company.' }
    }
  }
};

export function profileChoiceCopy(language = 'en') {
  return copies[String(language).toLowerCase().split(/[-_]/)[0]] || copies.en;
}
